import {
    RESET_CREDIT_ACTION_STATE,
    RESET_CREDIT_STATE,
    GET_CREDIT_LISTING,
    GET_CREDIT_LISTING_SUCCESS,
    GET_CREDIT_LISTING_FAIL,
} from "./actionTypes";

export const getCreditListing = (data) => ({
    type: GET_CREDIT_LISTING,
    payload: data,
});

export const getCreditListingSuccess = data => ({
    type: GET_CREDIT_LISTING_SUCCESS,
    payload: data,
});

export const getCreditListingFail = error => ({
    type: GET_CREDIT_LISTING_FAIL,
    payload: error,
});

//reset
export const resetCreditActionState = () => {
    return {
        type: RESET_CREDIT_ACTION_STATE,
    }
}
export const resetCreditState = () => {
    return {
        type: RESET_CREDIT_STATE,
    }
}

